module.exports = __webpack_public_path__ + "img/maestro.1a6e4b1f.svg";